import { NameValuePair, KeyValue } from '../types/bff';

/**
 * Convierte un array de NameValuePair en un objeto clave-valor.
 */
export const arrayToObject = (arr: NameValuePair[] | null): KeyValue | null => {
	if (!arr) return null;

	const obj: KeyValue = {};
	for (const item of arr) {
		obj[item.name] = item.value;
	}

	return obj;
};
